import React from 'react';
import { useTranslation } from 'react-i18next';
import WizardNumberInput from 'components/v2/epd-wizard-inputs/WizardNumberInput';
import { useUpdateEpdGeneralInformation } from 'services/api/mutations';
import { useDictionaryValues, useEPDDefinitionInformation, useEpdReferenceFlow } from 'services/api/queries';
import { FieldPanelFullWidth } from 'styles/v2/Styles.styled';
import { EPD_DICTIONARY_CODES } from 'services/api/constants';

interface Props {
  epdId: string;
  epdVersionId: string;
  errors: any;
}

const MassOfDeclaredUnitSection: React.FC<Props> = ({ epdId, epdVersionId, errors }) => {
  const epdDefinitionInformation = useEPDDefinitionInformation(epdVersionId).data;
  const updateEpdGeneralInformation = useUpdateEpdGeneralInformation(epdVersionId);
  const referenceFlowData = useEpdReferenceFlow(epdVersionId).data;
  const { t } = useTranslation();

  const dictionariesValues = useDictionaryValues().data!;
  const isReferenceFlowMassSelected = dictionariesValues.some(
    (x) =>
      x.dictionaryCode === EPD_DICTIONARY_CODES.REFERENCE_FLOW_UNIT &&
      x.value.toLocaleLowerCase() === referenceFlowData?.unitId &&
      x.description === 'Mass (kg)'
  );

  return (
    <FieldPanelFullWidth>
      <WizardNumberInput
        key={JSON.stringify(referenceFlowData)}
        label={t('epdWizard.wizardStep2.properties.massOfDeclaredUnit.title')}
        tooltip={t('epdWizard.wizardStep2.properties.massOfDeclaredUnit.tooltip')}
        name="massOfDeclaredUnit"
        placeholder="Type number"
        defaultValue={epdDefinitionInformation?.massOfDeclaredUnit ?? null}
        onChanged={(propertyName, newValue) =>
          updateEpdGeneralInformation.mutate({
            epdId,
            versionId: epdVersionId,
            propertyName,
            newValue,
          })
        }
        error={errors.massOfDeclaredUnit}
        disabled={isReferenceFlowMassSelected}
        maxFractionDigits={5}
      />
    </FieldPanelFullWidth>
  );
};

export default MassOfDeclaredUnitSection;
